var typingTimer;

// Helper function to convert object to URL parameters is included form utils.js as objectToURLParams
// Helper function to serialize object to URL encoded string is included form utils.js as serialize

// NASEPTAVANI ADRES
function selectAddress(row, type) {
	document.querySelector('input[name="' + type + '_ruian"]').value = row.dataset.ruian;
	document.querySelector('input[name="' + type + '_full_address"]').value = row.innerHTML;
	unmark_invalid(document.querySelector('input[name="' + type + '_full_address"]'), "div.form-group", true);

	address = getAddressDetail(row.dataset.ruian);
	const ruianDataEl = document.querySelector('input[name="' + type + '_ruian_data"]')
	ruianDataEl.value = JSON.stringify(address);
	if (address == null) {
		// je treba rozpasovat na jednotlive slozky
		var street = '';
		var city = '';
		var zip = '';
		var addr_parts = row.innerHTML.split(", ");
		if (addr_parts.length == 3) {
			street = addr_parts[0];
			street = street.replace(" č.p.", "").replace(" č.ev.", "");
			city = addr_parts[1];
			city = city.substring(0, city.indexOf(" ("));
			zip = addr_parts[2];
		} else if (addr_parts.length == 2) {
			city = addr_parts[0];
			city = city.replace(/ *\([^)]*\)/g, "");
			city = city.replace(" č.p.", "").replace(" č.ev.", "");
			city_parts = city.split(" ");
			num = city_parts.pop();
			street_arr = city_parts.slice(Math.floor(city_parts.length / 2));
			street = street_arr.join(" ") + " " + num;
			city_arr = city_parts.slice(0, Math.floor(city_parts.length / 2));
			city = city_arr.join(" ");
			zip = addr_parts[1];
		} else {
			console.log("Neznámý formát adresy!!!");
			return;
		}
	} else {
		street = address.street;
		if (street == "")
			street = address.cityPart;
		street += " " + address.streetNumber1;
		if (address.streetNumber2 != "")
			street += "/" + address.streetNumber2;

		city = address.city;
		zip = address.postalCode;
	}

	// Set street value only if the element exists
	var streetInput = document.querySelector('input[name="' + type + '_street"]');
	if (streetInput) {
		streetInput.value = street;
		streetInput.setAttribute('value', street);
		unmark_invalid(streetInput, undefined);
	}

	// Set city value only if the element exists
	var cityInput = document.querySelector('input[name="' + type + '_city"]');
	if (cityInput) {
		cityInput.value = city;
		cityInput.setAttribute('value', city);
		unmark_invalid(cityInput, undefined);
	}

	// Set zip value only if the element exists
	var zipInput = document.querySelector('input[name="' + type + '_zip"]');
	if (zipInput) {
		zipInput.value = zip;
		zipInput.setAttribute('value', zip);
		unmark_invalid(zipInput, undefined);
	}

	// schovame hinty
	row.closest(".hintaddress").style.display = 'none';
	// throw change on ruian
	ruianDataEl.dispatchEvent(new Event('change', { bubbles: true }));
}

var handleAddressHint = function (ev, input) {

	var target = ev.target;
	var val = target.value;
	var qry_args = {
		"address": val,
		"limit": 20
	};

	var req = new XMLHttpRequest();
	req.onreadystatechange = function () {
		if (req.readyState == XMLHttpRequest.DONE) {
			//removeHintBox();
			if (req.status == 200) {
				data = JSON.parse(req.responseText);
				adds = data.addresses;
				if (adds.length == 0) { // error or no results
					// removeHintBox();
				} else {
					box = input.closest('.form-group-hintaddress').querySelector('.hintaddress');
					box.style.display = 'block';
					type = input.dataset.address_type;
					box.querySelectorAll('div[rel="hint"]').forEach(function (hint) {
						hint.remove();
					});
					for (i = 0; i < adds.length; i++) {
						hint = '<div class="hintaddress__item" rel="hint" data-ruian="' + adds[adds.length - i - 1].id + '">' + adds[adds.length - i - 1].text + '</div>';
						box.insertAdjacentHTML('afterbegin', hint);
					}
					box.querySelectorAll('div[rel="hint"]').forEach(function (hintEl) {
						if (hintEl.dataset.hintBinded) {
							return; // already bound
						}
						hintEl.addEventListener('click', function () { selectAddress(this, type); });
						hintEl.dataset.hintBinded = true; // mark as bound
					});
				}
			} else {
				console.log("Při hledání došlo k chybě, zkuste později.");
				console.log(req.responseText);
			}
		}
	};

	req.open("GET", "/ajax/solar_find_address?" + objectToURLParams(qry_args), true);
	req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	req.send();
	return true;
};

function getAddressDetail(ruian) {

	var address = null;
	var qry_args = {
		"ruian": ruian
	};

	var req = new XMLHttpRequest();
	req.onreadystatechange = function () {
		if (req.readyState == XMLHttpRequest.DONE) {
			if (req.status == 200) {
				data = JSON.parse(req.responseText);
				address = data.address;
			} else {
				console.log("Při hledání došlo k chybě, zkuste později.");
				console.log(req.responseText);
			}
		}
	};

	req.open("GET", "/ajax/solar_get_address?" + objectToURLParams(qry_args), false);
	req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	req.send();
	return address;
};

function invalidateRuianAddress(address_type) {
	mark_invalid(document.getElementById(address_type + '_full_address'), undefined);
	var ruianEl = document.getElementById(address_type + '_ruian');
	ruianEl.value = '';
	ruianEl.setAttribute('value', '');
	var ruianDataEl = document.getElementById(address_type + '_ruian_data');
	ruianDataEl.value = '';
	ruianDataEl.setAttribute('value', '');
	var streetEl = document.getElementById(address_type + '_street');
	streetEl.value = '';
	streetEl.setAttribute('value', '');
	mark_invalid(streetEl, undefined);
	var cityEl = document.getElementById(address_type + '_city');
	cityEl.value = '';
	cityEl.setAttribute('value', '');
	mark_invalid(cityEl, undefined);
	var zipEl = document.getElementById(address_type + '_zip');
	zipEl.value = '';
	zipEl.setAttribute('value', '');
	mark_invalid(zipEl, undefined);
}

function initializeAddressHints() {

	document.querySelectorAll('.js-hint-address').forEach(function (element) {
		if (element.dataset.hintBinded) {
			return; // already bound
		}
		var addr_type = element.dataset.address_type;

		element.addEventListener("keyup", function (e) {
			if (e.keyCode == 13) { // ENTER
				/* var selected = document.querySelector(".hintrow.hover a");
				if (selected != null) {
					window.location = selected.getAttribute("href");
				} */
			} else if (e.key == 38 || e.key == "ArrowUp" || e.keyIdentifier == "Up") { // UP
				// selectRow("prev");
			} else if (e.key == 40 || e.key == "ArrowDown" || e.keyIdentifier == "Down") { //DOWN
				// selectRow("next");
			} else {
				if (typingTimer) {
					window.clearTimeout(typingTimer);
				}
				typingTimer = window.setTimeout(function () {
					handleAddressHint(e, element);
				}, 100);
			}
		});

		element.addEventListener("change", function () {
			let group = element.closest("div.form-group");
			// if (element.offsetParent !== null)
			//    invalidateRuianAddress(element.dataset.address_type);
		});

		element.dataset.hintBinded = true; // mark as bound
	});

	document.querySelectorAll('.js--toggle-shpping-data-form').forEach(function (element) {
		if (element.dataset.hintBinded) {
			return; // already bound
		}
		element.addEventListener('click', function () {
			document.querySelectorAll('button[type="submit"]').forEach(function (button) {
				button.setAttribute('disabled', 'disabled');
			});
		});
		element.dataset.hintBinded = true; // mark as bound
	});

	document.querySelectorAll('.js-address-commit-changes').forEach(function (element) {
		if (element.dataset.hintBinded) {
			return; // already bound
		}
		element.addEventListener('click', function () {
			document.body.classList.add("loading");
			var form = document.getElementById('payment_form');

			// v cart2 existuje pole msisdn, které by mělo měnit kontaktní telefon v účtu
			var msisdnEl = form.querySelector('input[name="msisdn"]');
			if (msisdnEl) {
				// console.log("Changing MSISDN to:", msisdn.value);
				var phone = msisdnEl.value;
				phone = check_contact_phone(phone);
				if (phone === null) {
					mark_invalid(msisdnEl, undefined);
					document.body.classList.remove("loading");
					scrollToElement(msisdnEl, -70);
					return false;
				} else {
					unmark_valid(msisdnEl, undefined);
					// save to parent - non editable label
					var msisdnLabel = form.querySelector('.msisdn__label--msisdn');
					if (msisdnLabel) {
						msisdnLabel.textContent = phone;
					}
				}

				var qry_args = {
					"msisdn": phone
				};
				var req = new XMLHttpRequest();
				req.onreadystatechange = function () {
					if (req.readyState === XMLHttpRequest.DONE) {
						if (req.status === 200) {
							var req_data = JSON.parse(req.responseText);
							if (req_data["status"] === 200) {
								console.debug("Changed contact phone to:", phone);
							}
							else {
								show_message(message_field, req_data["status_message"], "danger");
							}
						} else {
							alert("Chyba");
						}
					}
				};

				req.open("POST", "/ajax/change_contact_phone", false);
				req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
				req.send(serialize(qry_args));
			} // konec kontaktního telefonu (msisdn)
			fv = is_full_address_valid(form, 'facturation');
			sv = is_full_address_valid(form, 'shipping');

			var fv_elem = document.getElementById('facturation_full_address');
			var sv_elem = document.getElementById('shipping_full_address');

			if (!checkinputs_addr_edit(form) || !fv) {
				if (!fv && fv_elem && fv_elem.offsetParent !== null)
					mark_invalid(fv_elem, undefined);
				if (!sv && sv_elem && sv_elem.offsetParent !== null)
					mark_invalid(sv_elem, undefined);
				document.body.classList.remove("loading");
				this.blur();
				scrollToElement(document.querySelector('.is-invalid'), -70);
				return false;
			}

			if (fv_elem && fv_elem.offsetParent !== null) {
				if (!updateCncAddress(form, "facturation")) {
					document.body.classList.remove("loading");
					this.blur();
					return false;
				}
			}

			var use_shipping = document.querySelector('.js-toggle-use-shipping-address');
			if (!use_shipping) {
				// není tu ten element takže jsem asi cart2
				// přepínátko pro fyické zboží a přihlášenou firmu
				inp_buy_billing_address = form.querySelector('input[name="buy_billing_address"]');
				if (inp_buy_billing_address && inp_buy_billing_address.checked) {
					if (!updateCncAddress(form, "shipping")) {
						document.body.classList.remove("loading");
						this.blur();
						return false;
					}
				}

			}
			else if (use_shipping.classList.contains("js-dont-modify")) {
				// do nothing
			}
			else if (document.getElementById('add_shipping_addressr').checked ||
				(sv_elem && sv_elem.offsetParent !== null)) {
				if (!updateCncAddress(form, "shipping")) {
					document.body.classList.remove("loading");
					this.blur();
					return false;
				}
				if (!use_shipping.checked) {
					use_shipping.checked = true;
					var collapse_shipping = document.getElementById('collapse_shipping_address_up');
					if (collapse_shipping) {
						collapse_shipping.classList.add('show');
					}
				}
			} else {
				if (use_shipping.checked) {
					use_shipping.checked = false;
					var collapse_use_shipping = document.getElementById('collapse_use_shipping_address_up');
					if (collapse_use_shipping) {
						collapse_use_shipping.classList.remove('show');
					}
				}
			}

			var formdata = document.getElementById('formdata');
			var formdataedit = document.getElementById('formdataedit');
			if (formdata) {
				formdata.classList.toggle('show');
			}
			if (formdataedit) {
				formdataedit.classList.toggle('show');
			}

			document.querySelectorAll('button[type="submit"]').forEach(function (button) {
				button.removeAttribute('disabled');
			});
			document.body.classList.remove("loading");
			if (this.dataset.reloadaftersave) {
				updateOrderDataCall({ "init": true });
			}
		});
		element.dataset.hintBinded = true; // mark as bound
	});

	document.querySelectorAll('.js-address-remove-changes').forEach(function (element) {
		if (element.dataset.hintBinded) {
			return; // already bound
		}
		element.addEventListener('click', function () {
			document.querySelectorAll('button[type="submit"]').forEach(function (button) {
				button.removeAttribute('disabled');
			});
		});
		element.dataset.hintBinded = true; // mark as bound
	});

	document.querySelectorAll('input[name="buy_company"]').forEach(function (element) {
		if (element.dataset.hintBinded) {
			return; // already bound
		}
		element.addEventListener('click', function () {
			if (!this.checked) {
				document.querySelectorAll('#collapse_company input').forEach(function (input) {
					input.value = '';
				});
			} else {
				unmark_valid(document.getElementById('ic'), undefined);
				unmark_valid(document.getElementById('dic'), undefined);
				unmark_valid(document.getElementById('company_name'), undefined);
			}
		});
		element.dataset.hintBinded = true; // mark as bound
	});

	document.querySelectorAll('.js-clean-ruian').forEach(function (element) {
		if (element.dataset.hintBinded) {
			return; // already bound
		}
		element.addEventListener('click', function () {
			var address_type = this.dataset.address_type;
			document.querySelector('input[name="' + address_type + '_ruian"]').value = '';
			document.querySelector('input[name="' + address_type + '_full_address"]').value = '';
		});
		element.dataset.hintBinded = true; // mark as bound
	});

	document.querySelectorAll('.js-company-info-add').forEach(function (element) {
		if (element.dataset.hintBinded) {
			return; // already bound
		}
		element.addEventListener('keyup', function () {
			if (this.value.length == 8) {
				getCompanyInfo(this.value);
			}
		});
		element.dataset.hintBinded = true; // mark as bound
	});

	document.querySelectorAll('.js-toggle-use-billing-address').forEach(function (element) {
		if (element.dataset.hintBinded) {
			return; // already bound
		}
		element.addEventListener('click', function () {
			if (this.dataset.default_facturation_address_id) {
				if (this.checked) {
					document.querySelectorAll('input[name="facturation_address_id"]').forEach(function (input) {
						input.value = element.dataset.default_facturation_address_id;
					});
				} else {
					document.querySelectorAll('input[name="facturation_address_id"]').forEach(function (input) {
						input.value = document.querySelector('input[name="shipping_address_id"]').value;
					});
				}
			} else if (this.dataset.default_shipping_address_id) {
				if (this.checked) {
					document.querySelectorAll('input[name="shipping_address_id"]').forEach(function (input) {
						input.value = element.dataset.default_shipping_address_id;
					});
				} else {
					document.querySelectorAll('input[name="shipping_address_id"]').forEach(function (input) {
						input.value = document.querySelector('input[name="facturation_address_id"]').value;
					});
				}
			}
		});
		element.dataset.hintBinded = true; // mark as bound
	});

	document.querySelectorAll('.js-toggle-use-shipping-address').forEach(function (element) {
		if (element.dataset.hintBinded) {
			return; // already bound
		}
		element.addEventListener('click', function () {
			if (this.dataset.default_shipping_address_id) {
				if (this.checked) {
					document.querySelectorAll('input[name="shipping_address_id"]').forEach(function (input) {
						input.value = element.dataset.default_shipping_address_id;
					});
				} else {
					document.querySelectorAll('input[name="shipping_address_id"]').forEach(function (input) {
						input.value = document.querySelector('input[name="facturation_address_id"]').value;
					});
				}
			} else if (this.dataset.default_facturation_address_id) {
				if (this.checked) {
					document.querySelectorAll('input[name="facturation_address_id"]').forEach(function (input) {
						input.value = element.dataset.default_facturation_address_id;
					});
				} else {
					document.querySelectorAll('input[name="facturation_address_id"]').forEach(function (input) {
						input.value = document.querySelector('input[name="shipping_address_id"]').value;
					});
				}
			}
		});
		element.dataset.hintBinded = true; // mark as bound
	});

	// hint address
	document.addEventListener('DOMContentLoaded', function () {
		document.querySelectorAll(".form-group-hintaddress").forEach(function (element) {
			if (element.dataset.hintBinded) {
				return; // already bound
			}
			element.addEventListener('focusin', function () {
				var box = this.querySelector(".hintaddress");
				var hints = box.querySelectorAll('div[rel="hint"]');
				hints.forEach(function (hint) {
					hint.remove();
				});
				box.style.display = 'block';
			});
			element.dataset.hintBinded = true; // mark as bound
		});
	});
	if (!document.hintBinded) {
		document.addEventListener('click', function (event) {
			var triggers = document.querySelectorAll(".form-group-hintaddress");
			var clickedInside = false;
			triggers.forEach(function (trigger) {
				if (trigger === event.target || trigger.contains(event.target)) {
					clickedInside = true;
				}
			});
			if (!clickedInside) {
				document.querySelectorAll(".hintaddress").forEach(function (element) {
					element.style.display = 'none';
				});
			}
		});
		document.hintBinded = true; // mark as bound
	}

	document.querySelectorAll('.js-toggle-company-type').forEach(function (element) {
		if (element.dataset.hintBinded) {
			return; // already bound
		}
		element.addEventListener('click', function () {
			var ic = document.getElementById('ic');
			var dic = document.getElementById('dic');
			var c_name = document.getElementById('company_name');

			if (this.checked) {
				ic.setAttribute('name', "facturation_ic");
				ic.classList.remove('js-addres_type-shipping');
				ic.classList.add('js-addres_type-facturation');

				dic.setAttribute('name', "facturation_dic");
				dic.classList.remove('js-addres_type-shipping');
				dic.classList.add('js-addres_type-facturation');

				c_name.setAttribute('name', "facturation_company");
				c_name.classList.remove('js-addres_type-shipping');
				c_name.classList.add('js-addres_type-facturation');

				unmark_valid(document.getElementById('facturation_full_address'), undefined);
				unmark_valid(document.getElementById('facturation_ruian'), undefined);
				unmark_valid(document.getElementById('facturation_street'), undefined);
				unmark_valid(document.getElementById('facturation_city'), undefined);
				unmark_valid(document.getElementById('facturation_zip'), undefined);
				unmark_valid(document.getElementById('facturation_country'), undefined);
				unmark_valid(document.getElementById('facturation_name'), undefined);
				unmark_valid(document.getElementById('facturation_surname'), undefined);
			} else {
				ic.setAttribute('name', "shipping_ic");
				ic.classList.remove('js-addres_type-facturation');
				ic.classList.add('js-addres_type-shipping');

				dic.setAttribute('name', "shipping_dic");
				dic.classList.remove('js-addres_type-facturation');
				dic.classList.add('js-addres_type-shipping');

				c_name.setAttribute('name', "shipping_company");
				c_name.classList.remove('js-addres_type-facturation');
				c_name.classList.add('js-addres_type-shipping');
			}
		});
		element.dataset.hintBinded = true; // mark as bound
	});

}

// DOPLNENI INFORMACI O FIRME Z ICO
function getCompanyInfo(ic) {
	var req = new XMLHttpRequest();
	req.onreadystatechange = function () {
		if (req.readyState == XMLHttpRequest.DONE) {
			if (req.status == 200) {
				data = JSON.parse(req.responseText);
				company = data.company;
				if ("state" in company && company.state == "ACTIVE") {
					unmark_invalid(document.querySelector('input#ic'), undefined);
					// pridam DIC, pokud je
					var dicUpdated = false;
					for (i = 0; i < company.ids.length; i++) {
						if (company.ids[i].id == "ID2") {
							var dicEl = document.querySelector('input#dic');
							dicEl.value = company.ids[i].value;
							dicEl.setAttribute('value', company.ids[i].value);
							unmark_invalid(dicEl, undefined);
							dicUpdated = true;
						}
					}

					if (!dicUpdated) {
						var dicEl = document.querySelector('input#dic');
						dicEl.value = "";
						dicEl.setAttribute('value', "");
						unmark_invalid(dicEl, undefined);
					}

					// pridam nazev firmy
					var companyNameEl = document.querySelector('input#company_name');
					companyNameEl.value = company.companyName;
					companyNameEl.setAttribute('value', company.companyName);
					unmark_invalid(companyNameEl, undefined);

					valid_billing_addr = ("mainAddress" in company);

					if (valid_billing_addr === true) {
						// pridam adresu
						street = (company.mainAddress.street == undefined) ? company.mainAddress.cityPart : company.mainAddress.street;
						city = (company.mainAddress.street == undefined) ? company.mainAddress.city : company.mainAddress.city + " - " + company.mainAddress.cityPart;
						full_address = street + " " + company.mainAddress.streetNumber + ", " +
							city + " (" + company.mainAddress.district + "), " + company.mainAddress.postalCode;
						document.querySelector('input[name="facturation_ruian"]').value = company.mainAddress.registerCode;
						document.querySelector('input[name="facturation_ruian"]').setAttribute('value', company.mainAddress.registerCode);
						document.querySelector('input[name="facturation_ruian_data"]').value = JSON.stringify(company.mainAddress);
						document.querySelector('input[name="facturation_ruian_data"]').setAttribute('value', JSON.stringify(company.mainAddress));
						document.querySelector('input[name="facturation_full_address"]').value = full_address;
						document.querySelector('input[name="facturation_full_address"]').setAttribute('value', full_address);
						unmark_invalid(document.querySelector('input[name="facturation_full_address"]'), undefined);
						document.querySelector('input[name="facturation_street"]').value = street + " " + company.mainAddress.streetNumber;
						document.querySelector('input[name="facturation_street"]').setAttribute('value', street + " " + company.mainAddress.streetNumber);
						document.querySelector('input[name="facturation_city"]').value = company.mainAddress.city;
						document.querySelector('input[name="facturation_city"]').setAttribute('value', company.mainAddress.city);
						document.querySelector('input[name="facturation_zip"]').value = company.mainAddress.postalCode;
						document.querySelector('input[name="facturation_zip"]').setAttribute('value', company.mainAddress.postalCode);

					}
				}
			} else {
				console.log("Při hledání došlo k chybě, zkuste později.");
				console.log(req.responseText);
			}
		}
	};

	req.open("GET", "/ajax/solar_get_company_info?ic=" + ic, true);
	req.send();
	return true;
}


function cnc_is_address_valid(form, address_type) {
	if (address_type !== 'facturation' && address_type !== 'shipping') {
		console.error("is_address_valid  dostala neznámý typ adresy", address_type);
		return false;
	}
	var isOK = true;
	// najdi mi fieldy adresy:
	for (var i = 0; i < form.elements.length; i++) {
		var field = form.elements[i];
		if (field.classList.contains('js-addres_type-' + address_type)) {
			var fieldOK = check_one_form_field(field);
			var fg = field.closest('div.form-group');
			if (!fieldOK) {
				if (fg != null) {
					mark_invalid(field, undefined);
				}
			} else {
				if (fg != null) {
					unmark_invalid(field, undefined, false);
				}
			}
			isOK = fieldOK && isOK;
		}
	}

	return isOK;
}

function is_full_address_valid(form, address_type) {
	var checkFields = ["_full_address", "_ruian", "_street", "_city", "_zip", "_country", "_supplement"];
	if (address_type !== 'facturation' && address_type !== 'shipping') {
		console.error("is_address_valid  dostala neznámý typ adresy", address_type);
		return false;
	}
	var isOK = true;
	// najdi mi fieldy adresy:
	for (var i = 0; i < form.elements.length; i++) {
		var field = form.elements[i];
		if (
			field.classList.contains('js-addres_type-' + address_type) &&
			checkFields.includes(field.name.replace(address_type, ""))
		) {
			var fieldOK = check_one_form_field(field);
			var fg = field.closest('div.form-group');
			if (!fieldOK) {
				if (fg != null) {
					mark_invalid(field, undefined);
				}
			} else {
				if (fg != null) {
					unmark_invalid(field, undefined, false);
				}
			}
			isOK = fieldOK && isOK;
		}
	}

	return isOK;
}

function updateCncAddress(form, address_type) {
	var message_field = form.querySelector(".settings_message");
	clear_message(message_field);

	// kontrola jestli je validní
	valid_address = cnc_is_address_valid(form, address_type);
	if (!valid_address) {
		// pokud ne kašlu na to
		if (!is_full_address_valid(form, address_type)) {
			full_addr_elem = document.getElementById(address_type + '_full_address');
			if (full_addr_elem && full_addr_elem.offsetParent !== null)
				mark_invalid(full_addr_elem, undefined);
		}
		console.log("Address " + address_type + " is not valid");
		scrollToElement(document.querySelector('.is-invalid'), -70);
		return false;
	}

	// teď data
	var qry_args = {
		address_type: address_type
	};

	var err = false;
	// projdu pole co jsou součástí téhle adresy a uložím si jejich hodnotu
	//  už je nekontroluji prootže už zkontrolavané jsou
	for (var i = 0; i < form.elements.length; i++) {
		var field = form.elements[i];
		if (field.classList.contains('js-addres_type-' + address_type)) {
			var value = field.type == 'checkbox' ? field.checked : field.value;
			if (field.name == 'facturation_name') {
				if (form.ico && form.ico.value) {
					value = "";
				} else if (value == "") {
					value = document.querySelector('input[name="shipping_name"]').value;
				}
			}
			else if (field.name == 'facturation_surname') {
				if (form.ico && form.ico.value) {
					value = "";
				} else if (value == "") {
					value = document.querySelector('input[name="shipping_surname"]').value;
				}
			}
			if (value) {
				if (typeof (field.dataset.field_name) === 'undefined') {
					console.warn("Missing dataset fieldname on", field);
					return false;
				}
				// telefon na rozdíl od jiných polí má normalizaci.
				if (field.dataset.field_name == 'phone') {
					if (check_msisdn(value) == null) {
						console.warn("Phone number is invalid");
						mark_invalid(field, "div.form-group", "invalid_text");
						err = true;
					}
				}
				// Asi to je špatně -> stripni _address
				qry_args[field.dataset.field_name] = value;

			}
		}
	}
	if (err) { return false; }
	// v psc zahazujeme mezery
	if (qry_args.zip) {
		qry_args.zip = qry_args.zip.replace(/\s/g, "");
	}

	var req = new XMLHttpRequest();
	req.onreadystatechange = function () {
		// readyState OPENED
		if (req.readyState === 0) {
			document.body.classList.add("loading");
		}
		// readyState HEADERS_RECEIVED
		else if (req.readyState === 2) {
			//document.body.classList.remove("loading");
		}
		else if (req.readyState === XMLHttpRequest.DONE) {
			if (req.status === 200) {
				var resp_data = JSON.parse(req.responseText);
				if (resp_data.status === 200) {
					show_message(message_field, "Změněno", "success");
					var prev_val_was_null = false;
					document.querySelectorAll("input[name=" + resp_data.address_type + "_address_id" + "]").forEach(function (input) {
						if (!input.value) {
							prev_val_was_null = true;
						}
						input.value = resp_data.address_id;
					});

					cncAddressChangedInPopupCart(resp_data.address_id, resp_data.address_type, resp_data.result, prev_val_was_null);
					setTimeout(function () {
						var message_field = form.querySelector(".settings_message");
						clear_message(message_field);
					}, 1000);
				}
				else {
					// TODO
					show_message(message_field, resp_data.status_message, "danger");
				}
			}
			else {
				alert("Chyba");
			}
			//document.body.classList.remove("loading");
		}
	};
	console.log("Addres is ok -> gonna save and actualize");
	req.open("POST", "/ajax/change_address", false);
	req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	req.send(serialize(qry_args));
	return true;
}


function cncAddressChangedInPopupCart(
	addressId, addressType, formData, forceServerCheck
) {
	var targetHtmlElement = document.querySelector('p.js--' + addressType + '_address');
	var html = [];
	var has_ruian = false;

	document.querySelectorAll('[class*="' + addressType + '_address__label--"]').forEach(function (el) {
		el.textContent = '';
		el.closest('div').style.display = 'none';
	});

	Object.keys(formData).forEach(function (index) {
		if (["address_type", "address_id", "type", "id", "ruian_data"].includes(index)) {
			return; // skip these
		}
		var value = '';
		if (index === 'country') {

			var selectElement = document.querySelector("select[name=" + addressType + "_country]");
			var name_val = selectElement ? selectElement.options[selectElement.selectedIndex] : null;
			if (name_val) {
				value = name_val.text;
			}
			if (!value) {
				value = formData[index];
			}
			if (value === 'CZ' || value === 'cz') {
				value = 'Česká republika';
			} else if (value === 'SK' || value === 'sk') {
				value = 'Slovenská republika';
			}
			if (typeof actualize_shipping_payment !== 'undefined') {
				if (!forceServerCheck) {
					old_value = targetHtmlElement.querySelector("." + addressType + "address__label--" + index);
					if (old_value && old_value.length) {
						old_value = old_value.textContent;
						forceServerCheck = (old_value && old_value.trim() != value);
					}
				}
				if (forceServerCheck) {
					// změna země znamená aktulizaci košíku
					fetch("/actualize-cart-on-address-change?type=" + addressType + "&address_id=" + addressId)
						.then(response => response.json())
						.then(function (response) {
							if (response.status === 500) {
								console.log(response.message);
							} else {
								actualize_shipping_payment("address-logged", response.mini_checkout, response.pricing, response.payment_options, response.shipping_options);
							}
						});
				}
			}

		} else {
			value = formData[index];
		}
		var labelElements = document.querySelectorAll('.' + addressType + '_address__label--' + index);
		labelElements.forEach(function (el) {
			el.innerHTML = value;
			if (value)
				el.closest('div').style.display = 'block';
		});

		if (index == "ruian" && value != '' && value !== undefined) {
			has_ruian = true;
			document.querySelectorAll('.js-address-' + addressType + '-warning').forEach(function (el) {
				el.style.display = 'none';
			});
		}
	});
	if (!has_ruian) {
		document.querySelectorAll('.js-address-' + addressType + '-warning').forEach(function (el) {
			el.style.display = 'block';
		});
	}

	if (targetHtmlElement) {
		targetHtmlElement.innerHTML = html.join('');
	}
}

function checkinputs_addr_edit(form) {
	ommit = ["shipping_id", "payment_id", "tos", "tos_general", "tos_physical", "newsletter", "tos_bleskmobil", "tos_cnc-vstupenky", "tos_digital", "tos_mallpay", "contest_consent"];
	var valid = true;
	form.querySelectorAll('input[type="text"]').forEach(function (input) {
		// if (input.offsetParent !== null) {
		if (!ommit.includes(input.getAttribute("name"))) {
			var eachValid = check_one_form_field(input);
			valid = valid && eachValid;
		}
	});

	form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
		// if (input.offsetParent !== null) {
		if (!ommit.includes(input.getAttribute("name"))) {
			var eachValid = check_one_form_field(input);
			valid = valid && eachValid;
		}
	});

	return valid;
}


// init
document.addEventListener('DOMContentLoaded', function () {
	initializeAddressHints();
});